export default "__VITE_ASSET__CufAWXwA__"